<template>
  <v-menu ref="datepicker" v-model="datepicker" :close-on-content-click="false" transition="scale-transition" offset-y
    max-width="290px" min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field :id="id" :label="label" :loading="loading" :disabled="disabled" :rules="rules" readonly flat solo
        dense class="" :class="className" :placeholder="btxPlaceholder" hide-details :clearable="clearable"
        :prepend-inner-icon="hidePrefixIcon ? '' : 'mdi-calendar'" v-bind="attrs" v-on="on"
        :value="formattedDate"></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :min="minDate"
      :max="computedMaxDate"
      :first-day-of-week="weekday"
      :type="calanderType"
      :disabled="disabled"
      :readonly="readonly"
      :range="isRange"
      @input="onDateInput"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import { getData } from '@/core/services/local.service'

export default {
  name: "date-picker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [Date, String, Array],
      default: null,
    },
    isRange: {
      type: Boolean,
      default: false,
    },
    maxRangeDays: {
      type: Number,
      default: 7,
    },
    calanderType: {
      type: String,
      default: 'date',
    },
    hidePrefixIcon: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: [Date, String],
      default: null,
    },
    maxDate: {
      type: [Date, String],
      default: null,
    },
    rules: {
      type: [Array, Object],
      default: () => {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "Date",
    },
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    contentClass: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      date: null,
      datepicker: false,
      AppConfiguration: {},
      timeFormat: null,
      dateTimeFormat: null,
      dateFormat: null,
    };
  },
  watch: {
    minDate() {
      this.date = this.isRange ? [] : null;
    },
    maxDate() {
      this.date = this.isRange ? [] : null;
    },
    date() {
      // For range, only emit when both dates are selected
      if (this.isRange) {
        if (Array.isArray(this.date) && this.date.length === 2) {
          this.emitValue();
        }
      } else {
        this.emitValue();
      }
    },
    value(val) {
      this.date = val;
    },
  },
  methods: {
    getAppConfig() {
      const _this = this;
      let data = getData('app-config')
      _this.AppConfiguration = data;
      _this.dateFormat = data.date_format;
      _this.dateTimeFormat = data.date_format + " " + data.time_format;
      _this.timeFormat = data.time_format;
    },
    emitValue() {
      this.$emit("input", this.date);
      this.$emit("change", this.date);
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format(this.dateFormat);
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    onDateInput(val) {
      if (this.isRange) {
        // Close picker only when both start & end dates are selected
        if (Array.isArray(val) && val.length === 2) {
          const sorted = [...val].sort();
          this.date = sorted;
          this.datepicker = false;
        }
      } else {
        this.datepicker = false;
      }
    },
  },
  computed: {
    // Dynamically cap end date based on maxRangeDays once start is chosen
    computedMaxDate() {
      if (this.isRange && Array.isArray(this.date) && this.date.length === 1) {
        const start = moment(this.date[0]);
        const cappedMax = start.add(this.maxRangeDays - 1, 'days').format('YYYY-MM-DD');

        // Respect the global maxDate prop if provided
        if (this.maxDate && cappedMax > this.maxDate) {
          return this.maxDate;
        }
        return cappedMax;
      }
      return this.maxDate || null;
    },

    btxPlaceholder() {
      if (this.isRange) return this.placeholder + " [DD/MM/YYYY ~ DD/MM/YYYY]";
      return this.placeholder + " [DD/MM/YYYY]";
    },

    formattedDate() {
      // Range mode formatting
      if (this.isRange) {
        if (!Array.isArray(this.date) || this.date.length === 0) return null;
        const sorted = [...this.date].sort();
        const fmt = (d) => {
          if (this.AppConfiguration && this.dateFormat) {
            return moment(d).format(this.dateFormat);
          }
          return moment(d).format('DD/MM/YYYY');
        };
        if (sorted.length === 1) return fmt(sorted[0]);
        return `${fmt(sorted[0])} ~ ${fmt(sorted[1])}`;
      }

      // Single date formatting (original logic preserved)
      if (this.calanderType === 'month' && this.date) {
        return moment(this.date).format('MMMM YYYY');
      }
      let Config = this.AppConfiguration;
      if (Config && this.date) {
        return moment(this.date).format(this.dateFormat);
      }
      return this.date;
    },

    weekday() {
      let Config = this.AppConfiguration;
      if (Config && Config.weekday == 1) {
        return 0;
      } else {
        return 1;
      }
    },
  },
  mounted() {
    this.date = this.value ?? (this.isRange ? [] : null);
    this.$nextTick(() => {
      if (!this.isRange) {
        this.emitValue();
      }
    });
    this.getAppConfig();
  },
};
</script>